export class BaseFilters {
    regions: string[] | undefined;
    countries: string[] | undefined;
    period: string | undefined;
    presentationType: string | undefined;
    translation: string | undefined;
    dateRange: string | undefined;

    constructor(
        regions?: string[],
        countries?: string[],
        period?: string,
        presentationType?: string,
        translation?: string,
        dateRange?: string,
    ){
        this.regions = regions;
        this.countries = countries;
        this.period = period;
        this.dateRange = dateRange;
        this.presentationType = presentationType;
        this.translation = translation;
    }

    toString(): string{
        return `regions=${this.regions}, 
                countries=${this.countries}, 
                period=${this.period}, 
                presentationType=${this.presentationType},
                translation=${this.translation},`;
    }
}

